import { createGetDataReducer } from "./CommonReducer";
import { AuthConstants } from "../../constants/ReduxConstants";

const LoginReducer = createGetDataReducer(AuthConstants?.LOGIN);
const ForgotPasswordReducer = createGetDataReducer(AuthConstants?.FORGOT_PASSWORD);
const ResetPasswordReducer = createGetDataReducer(AuthConstants?.RESET_PASSWORD);
const ProfileReducer = createGetDataReducer(AuthConstants?.PROFILE);
const ChangePasswordReducer = createGetDataReducer(AuthConstants?.CHANGE_PASSWORD);
const UpdateProfile = createGetDataReducer(AuthConstants?.UPDATE_PROFILE)

export const AuthReducers = {
    LoginState: LoginReducer,
    ForgotPasswordState: ForgotPasswordReducer,
    ResetPasswordState: ResetPasswordReducer,
    ProfileState: ProfileReducer,
    ChangePasswordState: ChangePasswordReducer,
    UpdateProfileState:UpdateProfile
}